import { render, staticRenderFns } from "./TrainingQualificationAdd.vue?vue&type=template&id=aa0ecb44"
import script from "./TrainingQualificationAdd.vue?vue&type=script&lang=ts"
export * from "./TrainingQualificationAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports